module.exports = __webpack_public_path__ + "public/img/30tzhfx.c6a01626.png";